// extracted by mini-css-extract-plugin
export default {"date":"NewsModal_date__xLuN5","body":"NewsModal_body__n8gvV"};